import { Injectable, inject } from '@angular/core';
import { DialogService } from '@core/services/dialog.service';
import { DataFilterAction } from '@shared/constants/data-filter-action';
import { TripFilterCrudDialogComponent } from '@pages/trips-page/components/trip-filter-crud-dialog/trip-filter-crud-dialog.component';
import { TripCrudDialogData } from '@pages/trips-page/interfaces';
import { DvDialogComponent } from '@devinco/ui/dds';

@Injectable({
  providedIn: 'root',
})
export class TripFilterCrudDialogService {
  private dialog = inject(DialogService);

  openFilterCrudDialog(
    filterId: number,
    dataFilterAction: DataFilterAction,
    extraData?: object
  ): DvDialogComponent<TripCrudDialogData, TripFilterCrudDialogComponent> {
    return this.dialog.open<TripCrudDialogData, TripFilterCrudDialogComponent>({
      size: 'sm',
      title: this.getFilterCrudModalTitleKey(dataFilterAction),
      confirmText: 'General.Save',
      cancelText: 'General.Cancel',
      hideFooter: true,
      contentComponent: TripFilterCrudDialogComponent,
      data: {
        entityId: filterId,
        dataFilterAction,
        ...extraData,
      },
    });
  }

  openCustomPeriodForbiddenModal(): DvDialogComponent<undefined, undefined> {
    return this.dialog.open({
      hideHeader: true,
      cancelText: undefined,
      size: 'sm',
      confirmText: 'General.Ok',
      contentText: 'Trip.CustomFilterPeriodForbidden',
    });
  }

  openIntervalInvalidModal(): DvDialogComponent<undefined, undefined> {
    return this.dialog.open({
      cancelText: undefined,
      hideHeader: true,
      size: 'sm',
      contentText: 'Trip.IntervalInvalid',
      confirmText: 'General.Ok',
    });
  }

  getFilterCrudModalTitleKey(dataFilterAction: DataFilterAction): string {
    switch (dataFilterAction) {
      case DataFilterAction.Add:
        return 'Report.AddModal.Title';
      case DataFilterAction.Copy:
        return 'Report.FilterCopyModal.Title';
      case DataFilterAction.Edit:
        return 'Report.RenameModal.Title';
      default:
        return '';
    }
  }
}
